import { store } from "./store";
import { encryptData, decryptData } from "../utils/jsUtils";

const TOKEN_COOKIE_NAME = "userToken";
const AUTOLOGIN_LS_KEY = "tempData";

export const setTokenCookie = (token, maxAgeSeconds = 60 * 60 * 24 * 7) => {
  if (!token) {
    return;
  }
  document.cookie = `${TOKEN_COOKIE_NAME}=${encodeURIComponent(token)};path=/;max-age=${maxAgeSeconds};SameSite=Lax`;
};

export const getTokenCookie = () => {
  const token = getCookie(TOKEN_COOKIE_NAME);
  if (token) {
    return decodeURIComponent(token);
  }

  const accessToken = getCookie("accessToken");
  if (accessToken) {
    return decodeURIComponent(accessToken);
  }

  return null;
};

export const clearTokenCookie = () => {
  document.cookie = `${TOKEN_COOKIE_NAME}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;SameSite=Lax`;
  document.cookie = "accessToken=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;SameSite=Lax";
  document.cookie = "user=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;SameSite=Lax";
};

// Return authorization header with token and userAgent
export function authHeader() {
  const state = store.getState();
  const user = state?.login?.user || null;
  const userTokenFromState = user && user.token ? user.token : null;
  const userToken = getTokenCookie() || userTokenFromState;

  let buildVersion = getCookie("buildVersion");
  if (buildVersion == null) {
    buildVersion = "205";
  }

  const headers = {
    Authenticate: userToken,
    "XT-UserAgent": "flukeconnect-website/" + buildVersion,
  };

  return headers;
}

export const getCookie = (name) => {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
};

export const getUser = (user) => {
  const userObj =
    user && user.user instanceof Array && user.user[0]
      ? user.user[0]
      : user && !(user.user instanceof Array)
      ? user.user
      : {};

  return userObj;
};

export const setCredentials = (email, password) => {
  const payload = JSON.stringify({ email, password });
  localStorage.setItem(AUTOLOGIN_LS_KEY, encryptData(payload));
};

export const getCredentials = () => {
  const raw = localStorage.getItem(AUTOLOGIN_LS_KEY);
  if (!raw) return null;
  try {
    const decrypted = decryptData(raw);
    if (!decrypted) return null;
    return JSON.parse(decrypted);
  } catch {
    return null;
  }
};

export const clearCredentials = () => {
  localStorage.removeItem(AUTOLOGIN_LS_KEY);
};
